export default "__VITE_ASSET__DV2W5qgx__"